import React, {Component} from 'react';
import './DepartmentFolderUploads.scss';
import Modal from '../../../shared/ui/Modal';
import {FormGroup, Input, Label, ModalBody, ModalFooter} from 'reactstrap';
import Checkbox from "../../../shared/forms/Checkbox";
import {ApiGet, ApiPatch} from "../../../shared/services/api-service";
import LoadingButton from "../../../shared/ui/LoadingButton";
import notificationsActionsCreator from "../../store/notifications/action-creators";
import {connect} from 'react-redux';
import classnames from 'classnames';

class DepartmentFolderUploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cssValidationClasses: {
        folderName: '',
      },
      folderName: '',
      selectedRoles: null,
      isEditFolderPermissionOpen: false,
      selectedFolder: null,
      selectedFolderName: '',
      isDeleteInProgress: false,
      selectedFolderIndex: null,
      isDropped: true,
      nextPositionIndex: null,
      destinationFolderIndex: null,
      isDoubleClick: true,
      nextPositionPlaceholder: ''
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.overFolderIndex !== prevProps.overFolderIndex) {
      this.setState({
        nextPositionPlaceholder: this.props.overFolderIndex
      })
    }
  }

  get filterFolders() {
    if (this.props.uploadedDocuments.length) {
      let folders = this.props.uploadedDocuments.filter(obj => obj.file.type === 'FOLDER');

      return folders.filter(folder => {
        return !folder.file.roles
          || this.props.userContext.scope === 'depadmin'
          || (folder.file.roles && folder.file.roles.includes(this.props.userContext.scope));
      });
    }

    return [];
  }

  handleBlur(event) {
    const { name, value } = event.target;
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  onRoleSelect(e, role) {
    let selectedRoles = this.state.selectedRoles !== null ? this.state.selectedRoles : this.props.roles;

    if (e.target.checked) {
      selectedRoles = [...selectedRoles.filter(r => r !== role), role];
    } else {
      selectedRoles = selectedRoles.filter(r => r !== role);
    }

    this.setState({
      selectedRoles
    });
  }

  isRoleSelected(role) {
    if (this.state.selectedRoles) {
      return this.state.selectedRoles.includes(role);
    }
    else {
      return true;
    }
  }

  closeModal() {
    this.props.onCreateFolderModalClose();

    this.setState({
      folderName: '',
      selectedRoles: null
    });
  }

  closeFolderPermissionsModal() {
    this.setState({
      isEditFolderPermissionOpen: false
    });
  }

  createFolder(folderName, selectedRoles) {
    this.props.onCreateClick(folderName, selectedRoles);

    this.setState({
      folderName: '',
      selectedRoles: null
    });
  }

  onEditPermissions(folder) {
    let selectedRoles = null;
    if (folder.file.roles) {
      selectedRoles = folder.file.roles;
    }

    this.setState({
      isEditFolderPermissionOpen: true,
      selectedFolder: folder,
      selectedFolderName: folder.file.name,
      selectedRoles
    });
  }

  editFolder() {
    const fileObj = {
      name: this.state.selectedFolderName,
      type: 'FOLDER',
      roles: this.state.selectedRoles
    }

    ApiPatch('/api/v1/department-files/' + this.state.selectedFolder.id, {
      department_file: {
        file: fileObj
      }
    }).then(uploadedFile => {
      this.props.onFolderEdit(this.state.selectedFolder.parent_id);

      this.setState({
        isEditFolderPermissionOpen: false
      })
    })
  }

  deleteFolder() {
    let parentId = this.state.selectedFolder.id;

    let parentIdStr = '';
    if (parentId) {
      parentIdStr = '?parent_id=';
      parentIdStr += parentId;
    }

    this.setState({
      isDeleteInProgres: true
    })

    return ApiGet('/api/v1/department-files' + parentIdStr)
      .then(uploadedDocuments => {
        if (!uploadedDocuments.length) {
          this.setState({
            isDeleteInProgres: false,
            isEditFolderPermissionOpen: false
          })
          this.props.onDelete(this.state.selectedFolder)
        } else {
          this.setState({
            isDeleteInProgres: false,
          })
          this.props.notifyError('You cannot delete non empty folder')
        }
      })
  }

  handleDrop(e) {
    if (this.state.nextPositionIndex !== null) {
      this.props.onUpdateUploadedDocumentsList(this.filterFolders[this.state.nextPositionIndex],
        this.filterFolders[this.state.selectedFolderIndex]);
    }
    else if (this.state.destinationFolderIndex) {
      if (!this.props.selectedFile) {
        this.props.onMoveFolderToAnotherFolder(this.filterFolders[this.state.selectedFolderIndex],
          this.filterFolders[this.state.destinationFolderIndex]);
      }
      else {
        this.props.onMoveFolderToAnotherFolder(this.props.selectedFile,
          this.filterFolders[this.state.destinationFolderIndex]);
      }
    }

    this.setState({
      selectedFolderIndex: null,
      nextPositionIndex: null,
      nextPositionPlaceholder: '',
      destinationFolderIndex: null,
      isDropped: true,
      isDoubleClick: true
    })

    document.body.style.overflow = "auto";
  }

  handleTouchMove(e) {
    const target = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
    const index = target.id.split('folder-');

    this.handleMove(index[1], target.id, e.touches[0].clientX);

    this.setState({
      isDoubleClick: false
    })
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();

    const index = e.target.id.split('folder-');

    this.handleMove(index[1], e.target.id, e.clientX);
  }

  handleMove(indexPosition, id, positionX) {
    let elem = document.getElementById(id);
    if (elem) {
      let folderElement = elem.getBoundingClientRect();
      const leftRightMargin = folderElement.width * 0.2;
      const centerMargin = folderElement.width * 0.3;

      if (Math.abs(folderElement.right - positionX) <= leftRightMargin && indexPosition > this.state.selectedFolderIndex) {
        // move after elemet (left to right move)

        this.setState({
          nextPositionIndex: indexPosition,
          nextPositionPlaceholder: 'right',
          destinationFolderIndex: null
        })
      }
      else if (Math.abs(folderElement.right - positionX) <= leftRightMargin && (this.state.selectedFolderIndex - 1) > indexPosition) {
        // move after elemet (right to left move)

        this.setState({
          nextPositionIndex: parseInt(indexPosition) + 1,
          nextPositionPlaceholder: 'left',
          destinationFolderIndex: null
        })
      }
      else if (Math.abs(folderElement.left - positionX) <= leftRightMargin && indexPosition < this.state.selectedFolderIndex) {
        // move before element (right to left move)

        this.setState({
          nextPositionIndex: indexPosition,
          nextPositionPlaceholder: 'left',
          destinationFolderIndex: null
        })
      }
      else if (Math.abs(folderElement.left - positionX) <= leftRightMargin && (indexPosition -1) > this.state.selectedFolderIndex) {
        // move before element (left to right move)

        this.setState({
          nextPositionIndex: parseInt(indexPosition) - 1,
          nextPositionPlaceholder: 'right',
          destinationFolderIndex: null
        })
      }
      else if (Math.abs(Math.abs((folderElement.left + folderElement.right) / 2) - positionX) <= centerMargin
        && indexPosition != this.state.selectedFolderIndex) {
        // place it inside

        this.setState({
          nextPositionIndex: null,
          nextPositionPlaceholder: indexPosition,
          destinationFolderIndex: indexPosition
        })
      }
      else {
        // reset

        this.setState({
          nextPositionIndex: null,
          nextPositionPlaceholder: '',
          destinationFolderIndex: null
        })
      }
    }
    else {
      // reset

      this.setState({
        nextPositionIndex: null,
        nextPositionPlaceholder: '',
        destinationFolderIndex: null
      })
    }
  }

  handleDragStart(e, folderIndex) {
    if (this.state.isDropped) {
      this.setState({
        selectedFolderIndex: folderIndex,
        isDropped: false,
        destinationFolderIndex: null
      })
    }


    document.body.style.overflow = "hidden";
  }

  handleDragEnd(e) {
    this.setState({
      selectedFolderIndex: null,
      nextPositionIndex: null,
      destinationFolderIndex: null,
      isDropped: true,
      isDoubleClick: true
    })

    document.body.style.overflow = "auto";
  }

  displayNewPosition(index) {
    if (this.state.nextPositionIndex == index) {
      return this.state.nextPositionPlaceholder;
    }

    return '';
  }

  overFolderClass(index) {
    if (this.state.nextPositionPlaceholder == index && this.state.nextPositionPlaceholder !== '') {
      return 'center';
    }

    return '';
  }

  render() {
    return (
      <div className="folder-uploads-container">
        {this.filterFolders.length > 0 &&
        <div className="folders-container">
          <h4>Folders</h4>

          <div className="folders-list"
            onDrop={(e) => this.handleDrop(e)}
            onTouchEnd ={(e) => this.handleDrop(e)}
            onDragOver={(e) => this.handleDragOver(e)}
            onTouchMove={(e) => this.handleTouchMove(e)}
          >
            {this.filterFolders.map((folder, index) => (
              <div className="folder-container" key={folder.id}>
                <div
                  className={classnames('folder', this.overFolderClass(index))}
                  id={`folder-${index}`}
                  onDoubleClick={() => this.props.onFolderOpenClick(folder)}
                  onTouchEnd={(e) => {
                    if (this.state.isDoubleClick) {
                      e.stopPropagation();
                      e.preventDefault();
                      this.props.onFolderOpenClick(folder);
                      this.setState({
                        isDoubleClick: true
                      })
                    }
                    else {
                      this.handleDragEnd(e);
                    }
                  }}
                  draggable={this.props.userContext.hasScope('depadmin')}
                  onDragStart={(e) => this.handleDragStart(e, index)}
                  onTouchStart={(e) => this.handleDragStart(e, index)}
                  onDragOver={(e) => this.handleDragOver(e)}
                  onTouchMove={(e) => this.handleTouchMove(e)}
                  onDragEnd={(e) => this.handleDragEnd(e)}
                >
                  {folder.file.name}

                  {this.props.userContext.hasScope('depadmin') &&
                    <div className="edit-folder-permissions" onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.onEditPermissions(folder)
                      }} >
                      <i className="fa fa-lock"/>
                    </div>
                  }
                </div>
                <div className={classnames('new-position-placeholder', this.displayNewPosition(index))}>

                </div>
              </div>
            ))}
            </div>
          </div>
        }
        {this.filterFolders.length === 0 &&
          <p className="no-files">There are no folders here</p>
        }

        <Modal
          isOpen={this.props.isCreateFolderOpen}
          onClose={() => this.closeModal()}
          title="Create new Folder"
        >
          <ModalBody>
            <FormGroup>
              <Label for="folderName">Folder Name *</Label>
              <Input
                className={this.state.cssValidationClasses.folderName}
                name="folderName"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                type="text"
                value={this.state.folderName}
              />
            </FormGroup>

            <FormGroup>
              <Label for="folderName">Who can view this folder?</Label>

              {this.props.rolesOptionsTranslated && this.props.rolesOptionsTranslated.map(role => (
                <Checkbox checked={this.isRoleSelected(role.scope)} onChange={e => this.onRoleSelect(e, role.scope)}
                  label={role.name} key={role.scope} />
              ))}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <button
              className="button secondary"
              onClick={() => this.createFolder(this.state.folderName, this.state.selectedRoles)}
            >
              Create
            </button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isEditFolderPermissionOpen}
          title="Manage folder permission"
          onClose={() => this.closeFolderPermissionsModal()}
        >
          <ModalBody>
            <FormGroup>
              <Label for="folderName">Folder Name *</Label>

              <Input
                name="selectedFolderName"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                type="text"
                value={this.state.selectedFolderName}
              />
            </FormGroup>
            <FormGroup>
              <Label for="folderName">Who can view this folder?</Label>

              {this.props.rolesOptionsTranslated && this.props.rolesOptionsTranslated.map(role => (
                <Checkbox checked={this.isRoleSelected(role.scope)} onChange={e => this.onRoleSelect(e, role.scope)}
                          label={role.name} key={role.scope} />
              ))}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              text="Delete"
              danger={true}
              onClick={() => this.deleteFolder()}
              isLoading={this.state.isDeleteInProgres}
            />

            <button
              className="button secondary"
              onClick={() => this.editFolder()}
            >
              Update
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    notifyError: (message) =>
      dispatch(notificationsActionsCreator.addError(message))
  }
}

export default connect(null, mapDispatchToProps)(DepartmentFolderUploads)
